import React from 'react';
import SmartToyOutlinedIcon from '@mui/icons-material/SmartToyOutlined';
import { NODE_COLORS } from '../../config/theme';
import TextEditorModal from './TextEditorModal';

export default function PromptEditor({ open, onClose, selectedNode, availableVariables = [], onSave }) {
  return (
    <TextEditorModal
      open={open}
      onClose={onClose}
      title="Prompt Editor"
      nodeLabel={selectedNode?.data?.label}
      nodeColor={NODE_COLORS.AI}
      nodeIcon={<SmartToyOutlinedIcon sx={{ fontSize: 16 }} />}
      value={selectedNode?.data?.prompt || ''}
      onSave={onSave}
      availableVariables={availableVariables}
      placeholder={"Write your AI prompt here...\n\nUse {{VariableName}} to reference inputs from connected nodes.\nBe specific and clear about what you want the AI to do."}
    />
  );
}
